import React from "react";
import { FaClipboardList, FaClock, FaExclamationCircle, FaEye, FaCheckCircle, FaCalendarAlt } from "react-icons/fa";
import { STATUS_CONFIG } from "./constants";

export default function SummaryMetrics({ metrics }) {
  return (
    <div className="metrics-container">
      <div className="metrics-header">
        <h2>Dashboard Overview</h2>
        <p className="metrics-subtitle">Real-time submission statistics</p>
      </div>
      
      <div className="metrics-grid">
        <Metric 
          label="Total Submissions" 
          value={metrics.total}
          icon={<FaClipboardList />}
          color="#3b82f6"
          type="primary"
        />
        <Metric 
          label="Pending Review" 
          value={metrics.pending}
          status="Pending"
          icon={<FaClock />}
        />
        <Metric 
          label="Correction Needed" 
          value={metrics.correction}
          status="Correction Requested"
          icon={<FaExclamationCircle />}
        />
        <Metric 
          label="Reviewed" 
          value={metrics.reviewed}
          status="Reviewed"
          icon={<FaEye />}
        />
        <Metric 
          label="Approved" 
          value={metrics.approved}
          status="Approved"
          icon={<FaCheckCircle />}
        />
        <Metric 
          label="Today" 
          value={metrics.today}
          icon={<FaCalendarAlt />}
          color="#8b5cf6"
          type="secondary"
        />
      </div>
    </div>
  );
}

function Metric({ label, value, status, icon, color, type }) {
  const statusConfig = status ? STATUS_CONFIG[status] : null;
  const bgColor = statusConfig?.light || color;
  const textColor = statusConfig?.color || color;

  return (
    <div
      className={`metric-card ${type || ""}`}
      style={{
        backgroundColor: bgColor,
        borderLeftColor: textColor,
      }}
    >
      <div className="metric-icon" style={{ color: textColor }}>
        {icon}
      </div>
      
      <div className="metric-content">
        <h4 className="metric-label">{label}</h4>
        <p className="metric-value" style={{ color: textColor }}>
          {value}
        </p>
      </div>
    </div>
  );
}
